const styles = {
  desktopHeader: {
    borderBottom: "1px solid #f3f4f6",
    py: 1.75,
    px: 2,
  },
  headerTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: "#101828",
    lineHeight: "20px",
    letterSpacing: "-0.15px",
  },
  headerSubtitle: {
    fontSize: 10,
    color: "#99a1af",
    lineHeight: "15px",
    letterSpacing: "0.12px",
    mt: "2px",
  },
  collectionTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: "#101828",
    lineHeight: "20px",
  },
  newListButton: {
    backgroundColor: "#1b4332",
    color: "white",
    textTransform: "none",
    fontSize: 12,
    fontWeight: 500,
    borderRadius: "10px",
    height: 28,
    px: 1.5,
    minWidth: 0,
    "& .MuiButton-startIcon": { mr: 0.5 },
    "&:hover": {
      backgroundColor: "#163528",
    },
  },
  headerIconButton: {
    color: "#99a1af",
    borderRadius: "10px",
    width: 28,
    height: 28,
    "&:hover": {
      backgroundColor: "#f9fafb",
    },
  },
  close: {
    fontSize: 14,
  },
  footer: {
    position: "absolute",
    backgroundColor: "white",
    bottom: 0,
    pb: { xs: 0, md: "8px" },
  },

  // Mobile
  header: {
    position: "sticky",
    zIndex: 2,
    backgroundColor: "primary.main",
    py: 0,
    px: 2,
  },
  headerButton: {
    color: "white",
    fontSize: 16,
  },
  mobileContainer: {
    maxHeight: "100svh",
    overflow: "hidden",
  },
};

export default styles;
